// extracted by mini-css-extract-plugin
export default {"root":"ProductAvailabilityBadge_root__h82sk"};